/* CHARGE! charge.js */
document.addEventListener('DOMContentLoaded', function () {

  /* Mobile nav toggle */
  var burger = document.getElementById('burger');
  var mobNav = document.getElementById('mobNav');
  if (burger && mobNav) {
    burger.addEventListener('click', function () {
      var open = mobNav.classList.toggle('open');
      burger.setAttribute('aria-expanded', String(open));
    });
  }

  /* FAQ accordion */
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isOpen = this.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.faq-q').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var a = b.nextElementSibling;
        if (a) a.hidden = true;
      });
      if (!isOpen) {
        this.setAttribute('aria-expanded', 'true');
        var ans = this.nextElementSibling;
        if (ans) ans.hidden = false;
      }
    });
  });

  /* Smooth scroll for anchor links */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = this.getAttribute('href').slice(1);
      var el = document.getElementById(id);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (mobNav) { mobNav.classList.remove('open'); }
      }
    });
  });

});
